import { render } from "./SendMail.vue?vue&type=template&id=3ce3dadd&scoped=true"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"

import "./SendMail.vue?vue&type=style&index=0&id=3ce3dadd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce3dadd"]])

export default __exports__